<div class="selector">
  <zah-clientnummer-qr-scan [hidden]="isNummerMode()"
    (scanSuccess)="onScanSuccess($event)"
    (scanError)="onScanError()"
    (noCamerasFound)="onNoCamerasFound()"
    (noCameraPermission)="onNoCameraPermission()">
  </zah-clientnummer-qr-scan>

  <zah-clientnummer-input [hidden]="isQrCodeMode()"
    (nummerInput)="onNummerInput($event)">
  </zah-clientnummer-input>

  <div class="buttons">
    @if (isQrCodeMode()) {
      <a
        mat-button
        color="primary"
        (click)="searchOnNummer()">
        Zoek nummer
      </a>
    }
    @if (isNummerMode()) {
      <a
        mat-button
        color="primary"
        (click)="searchOnQrCode()">
        Scan QR code
      </a>
    }
    @if (isQrCodeMode() && !isQrScannerEnabled()) {
      <button
        mat-raised-button
        [color]="actiePalette"
        (click)="searchOnQrCode()">
        {{actieLabel}}
      </button>
    }
  </div>
</div>
<div class="hint">
  <ng-content></ng-content>
</div>
